var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2622_10197)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 31,
    fill: "#00C67F",
    fillOpacity: 0.11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_10197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 32C38.7165 32 32 38.7165 32 47C32 55.2835 38.7165 62 47 62C55.2835 62 62 55.2835 62 47C62 38.7165 55.2835 32 47 32ZM47 59.4554C40.1228 59.4554 34.5446 53.8772 34.5446 47C34.5446 40.1228 40.1228 34.5446 47 34.5446C53.8772 34.5446 59.4554 40.1228 59.4554 47C59.4554 53.8772 53.8772 59.4554 47 59.4554ZM50.9408 39.7478C50.4085 39.6306 49.7891 39.567 49.0893 39.567C45.5167 39.567 43.0993 41.4319 42.4397 44.5859H41.375C41.2277 44.5859 41.1071 44.7065 41.1071 44.8538V45.7645C41.1071 45.9118 41.2277 46.0324 41.375 46.0324H42.2589C42.2489 46.1696 42.2489 46.3136 42.2489 46.4609V47.6964H41.375C41.2277 47.6964 41.1071 47.817 41.1071 47.9643V48.875C41.1071 49.0223 41.2277 49.1429 41.375 49.1429H42.3862C42.9621 52.4643 45.4129 54.433 49.0893 54.433C49.7891 54.433 50.4085 54.3761 50.9408 54.2623C51.0647 54.2355 51.1551 54.1283 51.1551 54.0011V52.5681C51.1551 52.4007 51.0011 52.2734 50.8371 52.3069C50.3449 52.4007 49.769 52.4442 49.1027 52.4442C46.8092 52.4442 45.269 51.2188 44.7567 49.1429H49.1295C49.2768 49.1429 49.3973 49.0223 49.3973 48.875V47.9643C49.3973 47.817 49.2768 47.6964 49.1295 47.6964H44.5625V46.4911C44.5625 46.3337 44.5625 46.1763 44.5725 46.029H49.1228C49.2701 46.029 49.3906 45.9085 49.3906 45.7612V44.8504C49.3906 44.7031 49.2701 44.5826 49.1228 44.5826H44.827C45.4029 42.6775 46.9129 41.5558 49.0993 41.5558C49.7656 41.5558 50.3415 41.606 50.8304 41.7031C50.8692 41.711 50.9093 41.7103 50.9477 41.7008C50.9862 41.6914 51.0221 41.6735 51.0528 41.6486C51.0836 41.6236 51.1084 41.5921 51.1255 41.5564C51.1426 41.5207 51.1516 41.4816 51.1518 41.442V40.0089C51.1518 39.8817 51.0647 39.7746 50.9408 39.7478Z",
    fill: "#20435D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2622_10197",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_2622_10197"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_10197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(32 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePayment);
export default __webpack_public_path__ + "static/media/secure-payment.1d4995f71966c4703a1ebe75bc1bd33e.svg";
export { ForwardRef as ReactComponent };